export default "__VITE_ASSET__DdSHygyD__"